import { UserAPI } from "API/userApi";
import { IPerson } from "interfaces/intarfaces";
import { setTimeoutAsync } from "./helpers";
import { resizeImages } from "./resizeImages";

const numberAttempts = 3;
const delay = 2 * 1000;

export const tryLoadAvatar = async (
  userID: string,
  colAttempts: number = 3
): Promise<[string, boolean]> => {
  let response;
  for (let _ = 0; _ < colAttempts; _++) {
    response = await setTimeoutAsync(async () => {
      const user: IPerson = await UserAPI.getUser(userID);

      return [
        (user && user.hasOwnProperty("thumbnail_url")
          ? user.thumbnail_url
          : "") as string,
        user.is_profile_complete
      ];
    }, delay);

    if (!!(response as [string, boolean])[0].length)
      return response as [string, boolean];
  }
  return ["", false];
};

export const uploadAvatar = async (
  avatar: File | undefined,
  userID: string | undefined
): Promise<[string, boolean | undefined]> => {
  if (!avatar || !userID?.length) return ["", undefined];

  const newImg = await resizeImages([avatar]);
  if (!newImg.length) return ["", false];

  const responseUpload = await UserAPI.uploadAvatar(userID, newImg[0], {
    showNotificationOnError: false
  });

  if (responseUpload.hasOwnProperty("success") && responseUpload.success) {
    return await tryLoadAvatar(userID, numberAttempts);
  }
  return ["invalid_type", false];
};
